(function() {
    function initFaqAccordion() {
        // Select all containers created by the Gutenberg block
        const faqContainers = document.querySelectorAll('.wp-block-remote-x-blocks-faq-accordion, .accordion-questions-container');

        faqContainers.forEach(container => {
            // Remove existing listener to prevent duplicates if script runs twice (optional safety)
            container.removeEventListener('click', handleAccordionClick);
            container.addEventListener('click', handleAccordionClick);
        });
    }

    function handleAccordionClick(event) {
        // Check if we clicked the button (or inside it)
        const button = event.target.closest('.accordion-trigger') || event.target.closest('.accordion-question button');
        
        if (button) {
            event.preventDefault(); 
            
            const questionWrapper = button.closest('.accordion-question');
            // If wrapper not found, stop
            if (!questionWrapper) return;

            const answerPanel = questionWrapper.querySelector('.accordion-answer-panel');
            const icon = button.querySelector('.d-arrow');

            if (answerPanel) {
                const isExpanded = answerPanel.classList.toggle('show');
                button.setAttribute('aria-expanded', isExpanded);
                
                if (icon) {
                    icon.classList.toggle('rotate');
                }
            }
        }
    }

    // Run immediately if DOM is ready, otherwise wait
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFaqAccordion);
    } else {
        initFaqAccordion();
    }
})();